<div id="backNavigation" *ngIf="isBackNavigationEnabled" class="back_Navigation">
	<a href="{{backNavigationURL}}" role="link"><i class="fas fa-arrow-left"></i>&nbsp;{{backNavigationText}}</a>
</div>